export class ModelRegistry {
  static models = {}
  
  static register(modelClass, modelName) {
    this.models[modelName] = modelClass
  }
  
  static find(className) {
    return this.models[className]
  }
  
  static all() {
    return Object.values(this.models)
  }
}